import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { styled } from '@mui/system';
import Spinner from '@components/Icons/Spinner';
const useStyles = makeStyles()((theme) => {
    return {
        core: {
            alignItems: 'center',
            display: 'inline-flex',
            fontFamily: theme.typography.fontFamily,
            justifyContent: 'center',
            backgroundColor: 'rgb(255, 196, 57)',
            width: '200px',
            height: '35px',
            border: 'none',
            '&:hover, &:active, &:focus': {
                filter: 'brightness(0.95)',
            },
        },
        roundCorners: {
            borderRadius: '4px',
        },
    };
});
const StyledLoadingSpinner = styled(Spinner) `
  font-size: 15px;
  width: 1.2em;
  height: 1.2em;
`;
const PaypalButton = React.forwardRef(({ className = undefined, id = undefined, type = 'button', disabled = false, loading = false, ariaLabel = undefined, testId = undefined, onClick = undefined, roundCorners = true, }, ref) => {
    const { classes, cx } = useStyles({ variant: 'primary' });
    const classNames = cx(classes.core, roundCorners && classes.roundCorners, className);
    return (_jsx("button", { ref: ref, className: classNames, type: type, id: id, disabled: disabled, "aria-label": ariaLabel, "data-testid": testId, onClick: onClick, children: loading ? _jsx(StyledLoadingSpinner, { title: "loading" }) : _jsx("img", { height: 18, src: "/img/paypal.svg", alt: "Paypal" }) }));
});
export default PaypalButton;
